module.exports = __webpack_public_path__ + "img/mtl.5f3eb77c.jpg";